import axios from 'axios'
import conf from '../../src/config/config';
export default() => {
    const url = conf.api_url,
        l = window.location,
        baseURL = l.protocol + '//' + url;
    return axios.create({baseURL});
}
